__turbopack_context__.v({
  "button": "OwT_UG_button",
  "buttonMinus": "OwT_UG_buttonMinus",
  "buttonPlus": "OwT_UG_buttonPlus",
  "container": "OwT_UG_container",
  "value": "OwT_UG_value",
});
